'use client'

import { ETrackingEvent } from '@/lib/gtm/type'
import { sendGTMEvent } from '@next/third-parties/google'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

export function GTMPageView() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (pathname) {
      sendGTMEvent({
        frontendversion: document?.documentElement?.lang || 'vi',
        event: ETrackingEvent.PageView,
        page_path: pathname,
        page_location: window.location.href,
      })
    }
  }, [pathname, searchParams])

  return null
}
